import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_STARTER_EXPERIENCE_DASHBOARD_READY_TO_SHARE_FCM = createFcmDetails(
	'starter_experience_dashboard_ready_to_share_fcm',
	{
		owner: 'Axolotls',
		context: 'Starter Dashboard',
		description: 'Shows a Pre-made post module only to US users',
		import: false,
		template: {
			experimentName: undefined,
		},
	},
);
